import {
  BooleanField,
  NumberField,
  SelectField,
  TextField,
  useStudioForm,
} from "~/components/Form";
import { FiltersSidebar, withoutBaseTableModel } from "~/components/Table";
import { CommonFilters } from "~/domain/common";
import { processStateOptions, WorkflowSelect } from "~/lqs";
import { listIngestionPartsSchema } from "../schemas";
import { useIngestionPartSearchRequest } from "./IngestionPartTable";

export function IngestionPartFilters() {
  const [request, setRequest] = useIngestionPartSearchRequest();

  const { control, handleSubmit } = useStudioForm({
    schema: listIngestionPartsSchema,
    values: withoutBaseTableModel(request),
    onSubmit: setRequest,
  });

  return (
    <FiltersSidebar handleSubmit={handleSubmit}>
      <TextField control={control} name="id" />
      <NumberField control={control} name="sequence" />
      <TextField control={control} name="source" />
      <WorkflowSelect control={control} name="workflowId" />
      <BooleanField control={control} name="workflowIdNull" />
      <SelectField
        control={control}
        name="state"
        options={processStateOptions}
      />
      <CommonFilters control={control} />
    </FiltersSidebar>
  );
}
